import { render, staticRenderFns } from "./LocaleSmall.vue?vue&type=template&id=fe04228c"
import script from "./LocaleSmall.vue?vue&type=script&lang=js"
export * from "./LocaleSmall.vue?vue&type=script&lang=js"
import style0 from "./LocaleSmall.vue?vue&type=style&index=0&id=fe04228c&prod&lang=css"
import style1 from "./LocaleSmall.vue?vue&type=style&index=1&id=fe04228c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports